/** @jsx jsx */
import { css, jsx, SerializedStyles } from '@emotion/core';

import { ICustomTheme } from 'interfaces';

const buttonWidth = 240;

const cssSwitchButton =
  (secondLabel: string, checked: boolean) =>
  (theme: ICustomTheme): SerializedStyles =>
    css({
      background: theme.colors.white,
      border: `solid 1px ${theme.colors.grey.light2}`,
      borderRadius: 30,
      color: checked ? theme.colors.white : theme.colors.grey.light2,
      paddingRight: buttonWidth / 2,
      position: 'relative',
      textAlign: 'center',
      transition: `color ${theme.transitions.duration.standard}ms`,
      width: buttonWidth,

      //   The second toggle
      '&:before': {
        alignItems: 'center',
        bottom: 0,
        content: `"${secondLabel}"`,
        display: 'flex',
        justifyContent: 'center',
        pointerEvents: 'none',
        position: 'absolute',
        top: 0,
        right: 0,
        width: buttonWidth / 2,
        zIndex: 3,
      },
    });

const checkbox = css({
  test: 12,
  cursor: 'pointer',
  position: 'absolute',
  top: 0,
  left: 0,
  bottom: 0,
  width: '100%',
  height: '100%',
  opacity: 0,
  zIndex: 2,
});

const cssSlidder = (checked: boolean) => (theme: ICustomTheme) =>
  css({
    color: checked ? theme.colors.grey.light2 : theme.colors.white,
    display: 'block',
    padding: theme.spacing(1.5, 0),
    pointerEvents: 'none',
    position: 'relative',
    userSelect: 'none',
    '&:before': {
      backgroundColor: theme.colors.paletteFromBO.main,
      borderRadius: 30,
      content: '""',
      height: '100%',
      left: 0,
      position: 'absolute',
      top: 0,
      transform: checked ? `translateX(${buttonWidth / 2}px)` : 'translateX(0)',
      transition: checked
        ? `transform ${theme.transitions.duration.standard}ms linear, color ${theme.transitions.duration.standard}ms`
        : `transform ${theme.transitions.duration.standard}ms`,
      width: '100%',
    },
  });

type SwitchButtonProps = {
  firstLabel: string;
  secondLabel: string;
  checked: boolean;
  onClick: () => void;
};

const SwitchButton = ({
  firstLabel,
  secondLabel,
  checked,
  onClick,
}: SwitchButtonProps): JSX.Element => (
  <div css={cssSwitchButton(secondLabel, checked)}>
    <input
      aria-controls="sorting"
      css={checkbox}
      type="checkbox"
      onClick={onClick}
      id="sorting"
      name="sorting"
    />
    <label aria-controls="sorting" css={cssSlidder(checked)} htmlFor="sorting">
      <span css={{ position: 'relative' }}>{firstLabel}</span>
    </label>
  </div>
);

export default SwitchButton;
